import { Typography } from "@/frontend/shared/ui/Typography";
import styles from "./MarketFactsAndFiguresContainer.module.scss";
import clsx from "clsx";

function getActualValue(item: any) {
  if (item.value.includes("000000000000")) {
    if (item.unit?.includes("T USD")) {
      return item.value.slice(0, -12);
    }
  }

  if (item.value.includes("000000000")) {
    if (item.unit?.includes("B USD")) {
      return item.value.slice(0, -9);
    }
  }

  if (item.value.includes("000000")) {
    if (item.unit?.includes("M USD")) {
      return item.value.slice(0, -6);
    }
  }

  if (item.value.includes("000")) {
    if (item.unit?.includes("K USD")) {
      return item.value.slice(0, -3);
    }
  }

  const numericValue = Number(item.value);
  if (!isNaN(numericValue)) {
    if (numericValue >= 1e12) {
      return `${(numericValue / 1e12).toFixed(2)}T`;
    }

    if (numericValue >= 1e9) {
      return `${(numericValue / 1e9).toFixed(2)}B`;
    }

    if (numericValue >= 1e6) {
      return `${(numericValue / 1e6).toFixed(2)}M`;
    }

    if (numericValue >= 1e3) {
      return `${(numericValue / 1e3).toFixed(2)}K`;
    }

    return numericValue.toString();
  }

  return item.value;
}

export function MarketFactsAndFiguresContainer({ data, className }: { data: any; className?: string }) {
  const content = (
    <div className={clsx(styles.container, className)}>
      {data?.map((item: any, index: number) => (
        <div className={styles.block} key={index}>
          <Typography className={styles.subTitle} variant="label-4" color="greyscale600">
            {item.name}
          </Typography>
          <div className={styles.bottomBlock}>
            <Typography variant="label-3" color="greyscale900">
              {getActualValue(item)} {item.unit}
            </Typography>
            <Typography variant="body-3" color="greyscale700" className={styles.comment}>
              {item.comment}
            </Typography>
          </div>
        </div>
      ))}
    </div>
  );
  return content;
}
